/**
 * ParentUniformOrders — dedicated parent page listing all past
 * uniform orders. Always accessible from the sidebar regardless
 * of whether a campaign is open. iter307ag (Feb 2026).
 */
import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import PastUniformOrdersList from '../../components/parent/PastUniformOrdersList';

export default function ParentUniformOrders() {
  return (
    <DashboardLayout title="My Uniform Orders">
      <div className="space-y-4" data-testid="parent-uniform-orders-page">
        <p className="text-sm text-slate-500">
          A summary of every uniform order you've placed across campaigns.
        </p>
        <PastUniformOrdersList />
      </div>
    </DashboardLayout>
  );
}
